import { createSelector } from 'reselect';
import { createFeatureSelector } from 'common/create-feature-selector';
import { RootState, Dispatch } from 'store';
import { getDomain, getHostname, getRegion } from 'utils';
import { getQaCookies } from 'utils/get-qa-cookies';
import { getLangCookie } from 'utils/get-lang-cookie';
import { FetchModelProps } from 'features/page-model/types';
import { BRANDS_LIST_PATH_NAME } from 'common';
import { getEnv } from 'common/selectors';
import { fetchModelThunk } from './page-model-slice';
import { GetModelParams } from './api';

export const rootSelector = createFeatureSelector('pageModel');
export const getModelJson = createSelector(rootSelector, (s) => s.data);

export const getBreadcrumbs = createSelector(getModelJson, (m) => m?.breadcrumbs);
export const getSeoDescription = createSelector(getModelJson, (m) => m?.seoProperties.seotext);
export const getAnalytics = createSelector(getModelJson, (m) => m?.analytics || {});
export const getSeoProperties = createSelector(getModelJson, (m) => m?.seoProperties);
export const getPathname = createSelector(
  ({ router }: RootState) => router.path,
  (s) => s,
);
export const getHost = createSelector(
  ({ host }: RootState) => host,
  (s) => s,
);

export const getPageUrl = createSelector(getHost, getPathname, (host, pathName) => {
  const protocol = host?.includes('localhost') ? 'http://' : 'https://';
  return protocol + host + pathName;
});

export const fetchModel = () => async (dispatch: Dispatch, getState: () => RootState) => {
  const state = getState();
  const hostname = getHostname(state.host || '');
  const qaCookie = getQaCookies(state.cookie);
  const domain = getDomain(hostname);
  const region = getRegion(hostname, domain);
  const pathname = state.router?.path.replace(BRANDS_LIST_PATH_NAME, __NAME__);
  const lang = getLangCookie(state.cookie);
  const { ORCHESTRATOR_HOST, API_KEY, requestID } = getEnv(state);
  const params: FetchModelProps = {
    pathname,
    region,
    lang,
  };

  const options: GetModelParams = {
    host: ORCHESTRATOR_HOST || '',
    config: { headers: { 'x-api-key': API_KEY, 'x-request-id': requestID } },
    params,
  };

  if (qaCookie) {
    options.config = { headers: { cookie: qaCookie } };
  }

  return dispatch(fetchModelThunk(options));
};
